import React, { createContext, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Get language from localStorage or use browser default or fallback to 'en'
    return localStorage.getItem('language') || 
           (navigator.language && navigator.language.split('-')[0] === 'sw' ? 'sw' : 'en');
  });

  // On mount, set the language from state
  useEffect(() => {
    console.log("LanguageProvider: Setting initial language to", currentLanguage);
    i18n.changeLanguage(currentLanguage);
  }, []);

  // Function to change the language
  const changeLanguage = (lng) => {
    console.log("LanguageContext: Changing language to", lng);
    setCurrentLanguage(lng);
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  return (
    <LanguageContext.Provider value={{ currentLanguage, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext; 